import { Pagination, Tooltip, Button } from "antd";
import { useEffect, useState } from "react";
import { FiEye, FiTrash2 } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { Table } from "reactstrap";
import { deleteDocument } from "../../firebase/utility";
import useRowSelection from "../../views/Admin/customHooks/useRowSelection";
import DeleteModal from "../modals/DeleteModal";
import NotFoundDataUI from "../cards/NotFoundDataUI";

const VendorsTable = ({
  vendors,
  setSelectedData,
  page,
  setPage,
  pageSize,
  setPageSize,
  totalPages,
  gettingVendors,
  onClearSearch,
}) => {
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [id, setId] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const { selectedRows, handleViewSelected } = useRowSelection();

  useEffect(() => {
    const selected = handleViewSelected(vendors);
    setSelectedData(selected);
  }, [selectedRows]);

  const handleYesClick = () => {
    if (!id || !vendorData) return;

    const vendorName = vendorData?.billing?.[0]?.company || "Vendor";

    deleteDocument("Vendors", id).then(() => {
      toast.success(`${vendorName} with an ID (${id}) deleted successfully!`);

      gettingVendors();
      setVendorData(null);
      setId(null);
      toggle();
    });
  };

  return (
    <div>
      <DeleteModal
        modal={modal}
        handleDelete={handleYesClick}
        toggle={toggle}
      />

      <Table
        responsive
        hover
        bordered
        className="mb-0"
        style={{
          fontSize: "14px",
          overflow: "hidden",
          border: "1px solid #e2e8f0"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#00509d", color: "white" }}>
            <th className="text-center" style={{ borderBottom: "none" }}>Vendor ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>QB ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Vendor</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Vendor Phone</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Vendor Email</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {vendors?.length > 0 ? (
            vendors.map((row, index) => (
              <tr
                key={row._id}
                className="align-middle"
                style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                  borderBottom: "1px solid #f1f5f9"
                }}
              >
                <td className="text-center text-muted small fw-bold">{row?.id}</td>
                <td className="text-center">
                  {row?.quickbooks_id ? (
                    <span className="fw-semibold text-primary">{row?.quickbooks_id}</span>
                  ) : "-"}
                </td>
                <td className="text-center fw-bold">{row?.billing?.[0]?.company || "N/A"}</td>
                <td className="text-center">{row?.billing?.[0]?.phone || "N/A"}</td>
                <td className="text-center">{row?.billing?.[0]?.email || "N/A"}</td>

                <td className="text-center">
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <Tooltip title="View Details">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          history.push({
                            pathname: `/admin/vendors-details/${row._id}`,
                            state: row,
                          });
                        }}
                      >
                        <FiEye size={16} className="text-primary" />
                      </Button>
                    </Tooltip>

                    {(user?.role === "Admin" || user?.role === "Super-admin") && (
                      <Tooltip title="Delete Vendor">
                        <Button
                          color="link"
                          className="p-1 border-0"
                          onClick={() => {
                            setVendorData(row);
                            setId(row._id);
                            toggle();
                          }}
                        >
                          <FiTrash2 size={16} className="text-danger" />
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-5">
                <NotFoundDataUI 
                  message="Vendors not found!" 
                  onClearSearch={onClearSearch}
                />
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {vendors?.length > 0 && (
        <div className="d-flex justify-content-end mt-3 px-2">
          <Pagination
            current={page}
            total={totalPages}
            onChange={(value) => {
              localStorage.setItem("vendorPage", value);
              setPage(value);
            }}
            pageSize={pageSize}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setPage(1);
            }}
            pageSizeOptions={['10', '25', '50', '100']}
            size="small"
          />
        </div>
      )}
    </div>
  );
};

export default VendorsTable;
